var render, staticRenderFns
import script from "./WaitlistItemsTable.vue?vue&type=script&lang=ts"
export * from "./WaitlistItemsTable.vue?vue&type=script&lang=ts"
import style0 from "./WaitlistItemsTable.vue?vue&type=style&index=0&id=0ef80d26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports